import React, { Component } from "react";
import Styles from "./styles.module.css";
import { Link } from "react-router-dom";

export default class Tile extends Component<
  {
    img: string;
    hoverImg?: string;
    isBig?: boolean;
    imgNoFixedHeight?: boolean;
    header: string;
    text: string;
    link?: string;
  },
  { image: string }
> {
  constructor(props: any) {
    super(props);

    this.state = {
      image: this.props.img,
    };

    this.onTileEnter = this.onTileEnter.bind(this);
    this.onTileLeave = this.onTileLeave.bind(this);
  }
  render() {
    const tileClasses = this.props.isBig
      ? `${Styles.tile} ${Styles.big}`
      : this.props.imgNoFixedHeight
      ? Styles.tile
      : `${Styles.tile} ${Styles.imgFixedHeight}`;
    return (
      <Link
        to={this.props.link || ""}
        onMouseEnter={this.onTileEnter}
        onMouseLeave={this.onTileLeave}
      >
        <div className={tileClasses}>
          <div className={Styles.shade} />
          <img src={this.state.image} />
          <div className={Styles.content}>
            <div className={Styles.header}>{this.props.header}</div>
            <div className={Styles.text}>{this.props.text}</div>
          </div>
        </div>
      </Link>
    );
  }

  onTileEnter() {
    if (this.props.hoverImg) {
      this.setState({
        image: this.props.hoverImg,
      });
    }
  }

  onTileLeave() {
    if (this.props.hoverImg) {
      this.setState({
        image: this.props.img,
      });
    }
  }
}
